<app-modal class="hide-close-icon app-confirm-container" id="app-confirm">
    <div class="app-confirm">
        <div class="confirm-text" [innerHTML]="confirm?.text"></div>
        <div class="confirm-controls">
          <app-button *ngIf="confirm?.options?.showCancelButton == undefined || confirm?.options?.showCancelButton != false" style="width: 200px; flex: 1 1 0; max-width: 200px" [color]="confirm?.options?.cancelButtonColor || 'secondary'" variant="outlined" size="lg" (click)="onCancel()">{{confirm?.options?.cancelButtonText || 'Cancel'}}</app-button>
          <app-button style="width: 200px; flex: 1 1 0; max-width: 200px" [color]="confirm?.options?.confirmButtonColor || 'secondary'" size="lg" (click)="onConfirm()">{{confirm?.options?.confirmButtonText || 'Confirm'}}</app-button>
        </div>
    </div>
</app-modal>
